import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { ComponentLockRule } from "../../helpers/commonStatusHelpers";
import { getPitchInformationFormUrl } from "../../helpers/navigationHelpers";
import { useString } from "../../localization/localizationHelpers";
import { Forms, Programs } from "../../models/programsConfig";
import { NdaStatus, OnboardingProgram, PitchApplicationStep } from "../../models/status";
import { getNdaStatus } from "../../redux/selectors";
import { FormSummary } from "../FormSummary";

const formCardID = "PitchGameInformationFormSummary";

interface FormPitchInformationProps {
  statusMessage?: string;
}

export const FormPitchInformation = ({ statusMessage }: FormPitchInformationProps) => {
  const pitchInformationUnlockRule: ComponentLockRule = useMemo(
    () => ({
      program: Programs.Pitch,
      step: PitchApplicationStep.PitchInformation,
    }),
    []
  );
  const ndaStatus = useSelector(getNdaStatus);
  const signNdaToUnlock = useString("signNdaToUnlock");
  return (
    <FormSummary
      formName={Forms.PitchInformation}
      getFormUrl={getPitchInformationFormUrl}
      unlockRule={pitchInformationUnlockRule}
      lockRightSideText={ndaStatus !== NdaStatus.Signed ? signNdaToUnlock : undefined}
      formCardRule={{
        stepsToShow: new Set<PitchApplicationStep>([PitchApplicationStep.PitchInformation]),
        program: OnboardingProgram.PitchProgram,
        formCardId: formCardID,
      }}
      statusMessage={statusMessage}
    />
  );
};
